import { cloneDeep } from 'lodash';

function getTreatmentRowId(treatment: any) {
    return treatment?.postId ?? treatment?.["treatmentPostId"] ?? null;
}

function isSameTreatmentRow(existingTreatment: any, updatedTreatment: any) {
    const existingRowId = getTreatmentRowId(existingTreatment);
    const updatedRowId = getTreatmentRowId(updatedTreatment);

    if (existingRowId !== null || updatedRowId !== null) {
        return existingRowId === updatedRowId;
    }

    return existingTreatment?.["drug-code"] === updatedTreatment?.["drug-code"] &&
           existingTreatment?.["treatment-start"] === updatedTreatment?.["treatment-start"] &&
           existingTreatment?.["treatment-frecuency"] === updatedTreatment?.["treatment-frecuency"];
}

function stripTreatmentClientFields(treatment: any) {
    const { submission_id, createdAt, uuidResearcher, ...cleanedTreatment } = treatment;
    return cleanedTreatment;
}

export function buildTreatmentSaveValue({
    surveyField,
    treatments,
    initData,
    forceNewSubmissionAddButton = false,
}: {
    surveyField: any;
    treatments: any[];
    initData?: any;
    forceNewSubmissionAddButton?: boolean;
}) {
    if (
        forceNewSubmissionAddButton ||
        treatments.length !== 1 ||
        surveyField?.type !== "treatment_prescription"
    ) {
        return treatments;
    }

    const updatedTreatment = treatments[0];
    if (!updatedTreatment?.submission_id) {
        return treatments;
    }

    const existingRecord = initData?.surveyRecords?.find((record: any) =>
        record?.surveyField?.id === surveyField?.id && Array.isArray(record?.value)
    );
    const existingTreatments = existingRecord?.value;

    if (!Array.isArray(existingTreatments)) {
        return treatments;
    }

    const submissionTreatments = existingTreatments
        .filter((treatment: any) => treatment?.submission_id === updatedTreatment.submission_id)
        .map((treatment: any) => cloneDeep(treatment));

    if (submissionTreatments.length === 0) {
        return treatments;
    }

    return submissionTreatments.map((existingTreatment: any) =>
        isSameTreatmentRow(existingTreatment, updatedTreatment)
            ? { ...existingTreatment, ...cloneDeep(updatedTreatment) }
            : existingTreatment
    );
}

export function prepareTreatmentSurveyRecordForPersistence(surveyRecord: any) {
    const treatmentsValue = surveyRecord?.value;
    const treatmentData = treatmentsValue?.[0];

    if (!Array.isArray(treatmentsValue) || !treatmentData?.submission_id) {
        return null;
    }

    const cleanedTreatments = treatmentsValue.map((treatment: any) => stripTreatmentClientFields(treatment));

    const isStoppingTreatment = treatmentData?.["treatment-stoppedAt"] &&
                               treatmentData["treatment-stoppedAt"] !== "" &&
                               treatmentData["treatment-stoppedAt"] !== "NaN" &&
                               treatmentData["treatment-stoppedAt"] !== null;

    return {
        submissionId: treatmentData.submission_id,
        treatmentData,
        isStoppingTreatment,
        cleanedTreatments,
    };
}
